import { render } from "./Payment.vue?vue&type=template&id=da3d2ccc&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=da3d2ccc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da3d2ccc"

export default script